<template>
  <div>
    <pre-regis-stepper
      v-if="
        panel_state >= PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS &&
          !bypass
      "
      :page_step_panel_state="page_step_panel_state"
      :panel_state="panel_state"
      :PANEL_ALL_PAGE_STATE="PANEL_ALL_PAGE_STATE"
    />
    <v-row class="text-center grey lighten-2 mb-4 mx-auto" style="color: #555;">
      <v-col cols="12" md="4">
        {{ $t("pre_regis_panel.student_id") }} : {{ student_id }}
      </v-col>
      <v-col cols="12" md="4">
        {{ $t("pre_regis_panel.name_surname") }}:
        {{ inlineTranslator({ en: student_name_en, th: student_name_th }) }}
      </v-col>
      <v-col cols="12" md="4">
        {{ $t("pre_regis_panel.semester") }} : {{ semester }} / {{ year }}
      </v-col>
    </v-row>
    <!-- ------------------------------------------------ -->
    <div class="px-1 px-md-3 px-xl-6">
      <RegisMD
        v-if="bypass"
        :clear_student="clear_student"
        :fetch_student="fetch_student"
        :level_id="1"
        :sub_level_id="null"
        :year="year"
        :semester="semester"
        :student_id="student_id"
        :student_info="student_info"
        :regis_type="regis_type"
      />

      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.DISPLAY_FLOW_CHART">
        flow chart
        <pre-regis-flow-chart
          :clickNext="
            () =>
              (panel_state = PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS)
          "
        />
      </div>

      <div
        v-if="panel_state === PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS"
      >
        <pre-regis-confirm-consent
          :clickNext="() => (panel_state = PANEL_ALL_PAGE_STATE.ADD_SUBJECT)"
        />
      </div>

      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.ADD_SUBJECT">
        <regis-add-subject
          :clickNext="
            () => (panel_state = PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT)
          "
          :check_never_regis="check_never_regis"
          :year="year"
          :semester="semester"
          :student_id="student_id"
          :bypass="bypass"
        />
      </div>

      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT">
        <regis-complete
          :change_period="change_period"
          :withdraw_period="withdraw_period"
          :regis_type="regis_type"
          :year="year"
          :semester="semester"
          :student_id="student_id"
          :bypass="bypass"
        />
      </div>
      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.FALLBACK">
        ERROR: Fallback panel_state
      </div>
    </div>
  </div>
</template>

<script>
import RegisAddSubject from "./components/RegisAddSubject.vue";
import RegisComplete from "./components/RegisComplete.vue";
import PreRegisFlowChart from "./components/PreRegisFlowChart.vue";
import PreRegisStepper from "./components/PreRegisStepper.vue";
import { inlineTranslator } from "@/helper/translator";
import RegisMD from "./components/RegisMD.vue";

const PANEL_ALL_PAGE_STATE = {
  DISPLAY_FLOW_CHART: 0,
  CONFIRM_CONSENT_BEFORE_REGIS: 1,
  ADD_SUBJECT: 2,
  COMPLETE_SUBJECT: 3,
  FALLBACK: 99,
};

export default {
  name: "RegistrationPanel",
  components: {
    PreRegisStepper,
    PreRegisFlowChart,
    RegisAddSubject,
    RegisComplete,
    RegisMD,
  },
  props: {
    all_page_states: {
      type: Object,
    },
    page_state: {
      type: String,
      default: "",
    },
    change_period: {
      type: Boolean,
      default: false,
    },
    withdraw_period: {
      type: Boolean,
      default: false,
    },
    clear_student: {
      type: Function,
      default: null,
    },
    fetch_student: {
      type: Function,
      default: null,
    },
    check_never_regis: {
      type: Function,
      default: null,
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
    student_info: {
      type: Object,
      default: null,
    },
    regis_type: {
      type: String,
    },
    bypass: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    PANEL_ALL_PAGE_STATE,
  }),
  computed: {
    student_name_en() {
      if (this.currentStudentInfo)
        return (
          this.currentStudentInfo.fname_en +
          " " +
          this.currentStudentInfo.lname_en
        );
      return null;
    },
    student_name_th() {
      if (this.currentStudentInfo)
        return (
          this.currentStudentInfo.fname_th +
          " " +
          this.currentStudentInfo.lname_th
        );
      return null;
    },
    currentStudentInfo() {
      return this.student_info || this.$store.state.user.surrogated_student_info;
    },
    // ใช้ทำเส้น timeline เฉยๆ เลขจะตรงกับที่แสดงใน dot
    page_step_panel_state() {
      if (
        this.panel_state === PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS
      )
        return 1;
      if (this.panel_state === PANEL_ALL_PAGE_STATE.ADD_SUBJECT) return 2;
      if (this.panel_state === PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT) return 3;
      else return 0;
    },
    panel_state() {
      if (this.page_state === this.all_page_states.REGIS)
        // this.panel_state = PANEL_ALL_PAGE_STATE.DISPLAY_FLOW_CHART;
        return PANEL_ALL_PAGE_STATE.ADD_SUBJECT;
      else if (this.page_state === this.all_page_states.SUMMARY_REGIS)
        return PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT;
      return PANEL_ALL_PAGE_STATE.FALLBACK;
    },
  },
  methods: {
    inlineTranslator,
  },
};
</script>
